import * as React from 'react';
import cx from 'classnames';

import styles from './index.less';
// import deferLoadBetterQuicklink from '@src/utils/defer-load-better-quicklink';

export default class Root extends React.PureComponent {
  mainRef = React.createRef();

  componentDidMount() {
    const mainEl = this.mainRef.current;
    mainEl && (mainEl.scrollTop = 0);
    // deferLoadBetterQuicklink();
  }

  componentDidUpdate() {
    // deferLoadBetterQuicklink();
  }

  render() {
    const { className, children } = this.props;
    return (
      <div className={cx(styles.root, className)}>
        {/*<H5Orientation />*/}
        <div ref={this.mainRef} className={styles.main}>
          {children}
        </div>
      </div>
    );
  }
}
